import DirectorDocumentModule from './DirectorDocument.module';

export default DirectorDocumentModule;
